import { Form } from "antd";
import { useState, useEffect } from "react";

import DisplayAlerts from "./DisplayAlerts";
import ImportButton from "./ImportButton";
import { useImportContext } from "./ImportContext";
import ValidateImport from "./ValidateImport";

const UploadForm = () => {
  const [filePath, setFilePath] = useState();
  const [alerts, setAlerts] = useState([]);
  const { model } = useImportContext();

  const resetState = () => {
    setAlerts([]);
    setFilePath(null);
  };

  const onChange = ({ file }) => {
    if (file.status === "uploading" || file.status === "removed") {
      resetState();
    }
  };

  useEffect(() => {
    resetState();
  }, [model]);

  return (
    <Form layout="vertical" key={`uploadForm-${model}`}>
      <ValidateImport
        onChange={onChange}
        onSetAlerts={setAlerts}
        onSetFilePath={setFilePath}
      />

      {alerts.length > 0 && <DisplayAlerts alerts={alerts} />}

      <ImportButton
        filePath={filePath}
        onSetAlerts={setAlerts}
        onSetFilePath={setFilePath}
      />
    </Form>
  );
};

export default UploadForm;
